import { useCallback, useState } from 'react';

const useToggle = (initialState: boolean = false) => {
  const [isOn, setIsOn] = useState(initialState);

  const set = useCallback((value: boolean) => {
    setIsOn(value);
  }, []);

  const toggle = useCallback(() => {
    setIsOn((prev) => !prev);
  }, []);

  const setOff = useCallback(() => {
    setIsOn(false);
  }, []);

  const setOn = useCallback(() => {
    setIsOn(true);
  }, []);

  return { isOn, set, toggle, setOff, setOn };
};

export default useToggle;
